import { phone } from 'phone';
import { useCallback } from 'react';

export const formatDecoratedNumber = (phoneNumberString: string) => {
  const cleaned = phoneNumberString.replace(/\D/g, '');
  const match = cleaned.match(/^(?:\+?1)?(\d{0,3})(\d{0,3})(\d{0,4})$/);
  if (match) {
    const [, areaCode, firstPart, secondPart] = match;
    let formattedValue = '';
    if (areaCode) {
      formattedValue += `(${areaCode}`;
    }
    if (firstPart) {
      formattedValue += `) ${firstPart}`;
    }
    if (secondPart) {
      formattedValue += `-${secondPart}`;
    }
    return formattedValue;
  }
  return phoneNumberString;
};

export const useFormattedPhoneNumber = () => {
  const formatNumericPhoneNumber = useCallback((numberString: string) => {
    const normalizedNumber = phone(numberString);
    if (!phone(numberString).isValid) return numberString;
    return normalizedNumber.phoneNumber?.replace(/\D/g, '') ?? '';
  }, []);

  const formatDecoratedPhoneNumber = useCallback((numberString: string) => {
    return formatDecoratedNumber(numberString);
  }, []);

  return { formatNumericPhoneNumber, formatDecoratedPhoneNumber };
};
